import { cloneDeep } from 'lodash-es';

export const kebabCaseStringToSnake = (input: string) => {
  let str = input;
  let i = str.search(/.[-]./);

  while (i !== -1) {
    str = str.replace(str.charAt(i + 1), '_');
    i = str.search(/.[-]./);
  }
  return str;
};

export const snakeCaseStringToKebab = (input: string) => {
  let str = input;
  let i = str.search(/.[_]./);

  while (i !== -1) {
    str = str.replace(str.charAt(i + 1), '-');
    i = str.search(/.[_]./);
  }
  return str;
};

export const lowerCamelStringToSnake = (input: string) => {
  let str = input;
  let i = str.search(/[A-Z]/);

  while (i !== -1) {
    str = str.replace(str.charAt(i), `_${str.charAt(i).toLowerCase()}`);
    i = str.search(/[A-Z]/);
  }
  return str;
};

export const snakeCaseStringToLowerCamel = (input: string) => {
  let str = input;
  let i = str.search(/.[_]./);

  while (i !== -1) {
    str = str.replace(`_${str.charAt(i + 2)}`, str.charAt(i + 2).toUpperCase());
    i = str.search(/.[_]./);
  }
  return str;
};

export const kebabCaseStringToLowerCamel = (input: string) => {
  let str = input;
  let i = str.search(/.[-]./);

  while (i !== -1) {
    str = str.replace(`-${str.charAt(i + 2)}`, str.charAt(i + 2).toUpperCase());
    i = str.search(/.[-]./);
  }
  return str;
};

export const convertLowerCamelToSnake = (obj: object | null | string) => {
  // objectじゃなければ何も変換せず返す
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(convertLowerCamelToSnake);
  }

  const ret = {};
  for (const key in obj) {
    if (
      obj[key] !== null &&
      typeof obj[key] === 'object' &&
      !Array.isArray(obj[key])
    ) {
      obj[key] = convertLowerCamelToSnake(obj[key]);
    }
    if (Array.isArray(obj[key])) {
      obj[key] = obj[key].map((item) => {
        return convertLowerCamelToSnake(item);
      });
    }
    ret[lowerCamelStringToSnake(key)] = obj[key];
  }
  return ret;
};

export const convertSnakeToLowerCamel = (org: object | null | string) => {
  const obj = cloneDeep(org);
  // objectじゃなければ何も変換せず返す
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(convertSnakeToLowerCamel);
  }

  const ret = {};
  for (const key in obj) {
    if (
      obj[key] !== null &&
      typeof obj[key] === 'object' &&
      !Array.isArray(obj[key])
    ) {
      obj[key] = convertSnakeToLowerCamel(obj[key]);
    }
    if (Array.isArray(obj[key])) {
      obj[key] = obj[key].map((item) => {
        return convertSnakeToLowerCamel(item);
      });
    }
    ret[snakeCaseStringToLowerCamel(key)] = obj[key];
  }
  return ret;
};
